module.exports = __webpack_public_path__ + "img/caseBuilder-dataScientist.fe8210c1.webp";